import React, { useContext } from 'react';

import { LangContext } from 'providers/LangProvider';
import { Link } from 'gatsby';
import { Wrapper } from './styles';

// "IS · EN": the current language is plain text, the other one is a link.
// Rendered with `mobile` in the header bar so it's visible without opening the menu.
const LangSwitch = ({ mobile }) => {
  const { lang } = useContext(LangContext);

  return (
    <Wrapper mobile={mobile}>
      {lang === 'is' ? (
        <span aria-current="true">IS</span>
      ) : (
        <Link to="/" hrefLang="is" lang="is" aria-label="Íslenska">
          IS
        </Link>
      )}
      <span aria-hidden="true"> · </span>
      {lang === 'en' ? (
        <span aria-current="true">EN</span>
      ) : (
        <Link to="/en/" hrefLang="en" lang="en" aria-label="English">
          EN
        </Link>
      )}
    </Wrapper>
  );
};

export default LangSwitch;
